import { Theme } from '@mui/material';

export const APP_BAR_HEIGHT = 73;
export const NAV_BAR_LIST_ITEM_HEIGHT = 48;
export const NAV_BAR_DRAWER_RIGHT_SPACE = NAV_BAR_LIST_ITEM_HEIGHT / 2 + 8;
export const NAV_BAR_DRAWER_RIGHT_SPACE_COLLAPSED = (NAV_BAR_LIST_ITEM_HEIGHT / 2 + 8) / 2;
export const NAV_DRAWER_WIDTH = 192 + NAV_BAR_DRAWER_RIGHT_SPACE;
// export const NAV_DRAWER_WIDTH_COLLAPSED = (theme: Theme) =>
// 	`calc(${theme.spacing(6 + 6)} + 1px + 6px + ${NAV_BAR_DRAWER_RIGHT_SPACE_COLLAPSED * 2}px)`;

export function getNavDrawerCollapsedWidth(theme: Theme, breakpoint?: 'sm' | 'md') {
	// if (breakpoint === 'md') {
	// 	return `calc(${theme.spacing(9)} + 1px + ${NAV_BAR_LIST_ITEM_HEIGHT / 2}px + ${theme.spacing(2)})`;
	// }
	return `calc(${theme.spacing(6 + 6)} + 1px + 6px + ${
		NAV_BAR_DRAWER_RIGHT_SPACE_COLLAPSED * 2
	}px)`;
	// (9*4) + ((48/2 + 8)/2)
	// 36 + (24 + 8) / 2  = 52
	// 88px
}
